import { Component, Input } from '@angular/core';

/**
 * Generic stub section. The routes registry passes content via inputs,
 * so we don't need a separate component class per "Coming soon" page.
 */
@Component({
    standalone: false,
    selector: 'mkt-ws-stub',
    template: `
<mkt-ws-page-head [eyebrow]="eyebrow" [title]="title" [sub]="sub"></mkt-ws-page-head>
<mkt-ws-coming-soon
    [icon]="csIcon"
    [title]="csTitle"
    [body]="csBody"
    [legacyLabel]="legacyLabel"
    [legacyHref]="legacyHref">
</mkt-ws-coming-soon>
    `,
})
export class StubSection {
    @Input() companyId = '';
    @Input() companyName = '';
    @Input() eyebrow = '';
    @Input() title = 'Coming soon';
    @Input() sub = '';
    @Input() csIcon = 'fa-clock';
    @Input() csTitle = 'Coming soon';
    @Input() csBody = '';
    @Input() legacyLabel = '';
    @Input() legacyHref = '';
    // Workspace shared inputs — declared so *ngComponentOutlet doesn't error in strict mode
    @Input() blogs: unknown[] = [];
    @Input() socialPosts: unknown[] = [];
    @Input() newsletters: unknown[] = [];
    @Input() recommendations: unknown[] = [];
    @Input() contentStatuses: unknown[] = [];
    @Input() contentTypes: unknown[] = [];
    @Input() blogStatuses: unknown[] = [];
    @Input() socialPlatforms: unknown[] = [];
    @Input() channelConfigs: unknown[] = [];
    @Input() brandConfig: unknown = null;
    @Input() isLoadingContent = false;
    @Input() navigate: (path: string) => void = () => {};
}
